<template>
<div>
  <v-tabs style="margin-top:-1rem;" light v-model="tab" color="gray"  slider-color="transparent">
    <v-tab v-for="n in ['Tłumaczenia','Tłumaczenia automatyczne']" :key="n" ripple >{{ n }}</v-tab>

    <v-tab-item style="padding:2rem;" key="Tłumaczenia">
      <h2 style="margin-top:0rem;">Tłumaczenia</h2>
      <v-form ref="form">
        <v-select @change="changed()" :rules="nameRules" v-model="lang" label="Język" :items="langs"></v-select>
        <v-container>
          <div v-for="field in fields" :key="field.id">
            <v-text-field :rules="nameRules"  v-model="model[field.id]" :label="field.name"></v-text-field>
            <v-container v-if="field.type == 'radio'">
              <v-text-field v-for="value in field.values" :key="field.id +'-' + value.key"
                            :label="value.value" :rules="nameRules"
                            :value="getValueTranslation(value.key, field.id)" @change="setValueTranslation($event, value.key, field.id)">
              </v-text-field>
            </v-container>
          </div>
        </v-container>
        <v-btn @click="submit()">Ok</v-btn>
      </v-form>
    </v-tab-item >

    <v-tab-item style="padding:2rem;" key="Tłumaczenia automatyczne">
      <h2>Tłumaczenia automatyczne</h2>
      <div v-if="autoTranslationResults.length == 0">
        <span>
          Tłumaczenie zostanie wygenerowane automatycznie. Tłumaczenie może nie być w pełni dokładne lub może zawierać błedy.<br>
          <b>Proces tłumaczenia może potrwać kilka do nawet kilku dziesiesięciu sekund w zależnośći od tego jak rozbudowany jest schemat.</b>
        </span>
      </div>
      <div v-if="autoTranslationPendding && autoTranslationResults.length == 0">
        <span>Trwa tłumaczenie...</span>
        <v-progress-linear indeterminate  :value="40"></v-progress-linear>
      </div>
      <div style="margin-top:2rem" v-if="autoTranslationResults.length > 0">
        <h4>Wyniki tłumaczeń:</h4>
        <table>
          <tr><th>Język</th><th>Wynik</th></tr>
          <tr v-for="(translationRes,resIndex) in autoTranslationResults" :key="'res-' + resIndex">
            <td style="text-align: center">{{translationRes.language}}</td>
            <td style="text-align: center">{{translationRes.status}}</td>
          </tr>
        </table>
      </div>
      <v-btn v-if="!autoTranslationPendding" @click="autoTranslate()">Ok</v-btn>

    </v-tab-item>
  </v-tabs>
</div>
</template>

<script>
import langs from "@/plugins/langs"
import Messenger from "@/plugins/Messenger"

export default {
  data() {
    return {
      tab:0,
      autoTranslationPendding:false,
      autoTranslationResults:[],
      langs: langs.getSupportedLangs(),
      schema: {},
      model: {},
      valuesModel: {},
      translations: [],
      schemaFields: [],
      lang: "",
      nameRules: [
        (v) => !!v || this.$t('team.create.error.no-name-msg')
      ]
    }
  },
  computed: {
    fields() {
      let fields = []
      this.schemaFields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  created() {
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let translations = this.$http.get('schema/' + this.$route.params.schemaId + '/translations')

    Promise.all([schema, translations]).then((data) => {
      this.schemaFields = data[0].data.fields
      this.schema = data[0].data
      this.translations = data[1].data
    }).catch(() => {
      this.$route.push({
        name: "not-found"
      })
    })
  },
  methods: {
    autoTranslate(){
      this.autoTranslationPendding = true
      this.$http.post('schema/' + this.schema.id + '/auto-translate').then(data=>{
        this.autoTranslationResults = data.data.results
      }).catch(() => {
        Messenger.emitError("Error")
      })
    },
    getValueTranslation(valueKey, fieldId){
      if(!this.valuesModel[fieldId]){
        return ""
      }
      return this.valuesModel[fieldId][valueKey]
    },
    setValueTranslation(inputValue, valueKey,fieldId){
      if(!this.valuesModel[fieldId]){
        this.valuesModel[fieldId] = {}
      }
      this.valuesModel[fieldId][valueKey] = inputValue
    },
    getValuesTranslation(fieldId){
      if(!this.valuesModel[fieldId]){
        return []
      }
      let res = []
      for (let keyObj in this.valuesModel[fieldId]){
        res.push({ 'key' : keyObj, 'translation' : this.valuesModel[fieldId][keyObj]})
      }
      return res
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      let postData = this.createPostData()
      this.$http.post(`schema/${this.schema.id}/translations`, postData).then(data => {
        this.translations.push(data.data)
        this.$store.commit('setSnack', {
          message: "Dodano tłumaczenie",
          color: 'success'
        })
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Problem z dodaniem tłumaczenia",
          color: 'success'
        })
      })
    },
    createPostData() {
      return {
        'lang': this.lang,
        'translations': this.fieldsTranslation()
      }
    },
    fieldsTranslation() {
      let fieldsTranslation = []
      for (let fieldId in this.model) {
        fieldsTranslation.push({
          'id': fieldId,
          'translation': this.model[fieldId],
          'values' : this.getValuesTranslation(fieldId)
        })
      }
      return fieldsTranslation
    },
    changed() {
      this.model = {}
      this.valuesModel = {}
      let translations = this.translations.filter(v => v.lang == this.lang)
      translations.forEach(translation => {
        this.model[translation['id_field']] = translation['translation']

        if(translation.values && translation.values.length > 0) {
          translation.values.forEach(translationValue =>
            this.setValueTranslation(translationValue.translation, translationValue.key, translation['id_field']))
        }
      })
    }
  },
}
</script>
